"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var flex_layout_1 = require("@angular/flex-layout");
var material_module_1 = require("../material.module");
var loader_component_1 = require("./loader/loader.component");
var core_2 = require("@ngx-translate/core");
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule = tslib_1.__decorate([
        core_1.NgModule({
            imports: [
                flex_layout_1.FlexLayoutModule,
                material_module_1.MaterialModule,
                common_1.CommonModule,
                core_2.TranslateModule
            ],
            declarations: [
                loader_component_1.LoaderComponent
            ],
            exports: [
                loader_component_1.LoaderComponent,
                core_2.TranslateModule
            ]
        })
    ], SharedModule);
    return SharedModule;
}());
exports.SharedModule = SharedModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhcmVkLm1vZHVsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNoYXJlZC5tb2R1bGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsc0NBQXlDO0FBQ3pDLDBDQUErQztBQUMvQyxvREFBd0Q7QUFFeEQsc0RBQW9EO0FBQ3BELDhEQUE0RDtBQUM1RCw0Q0FBc0Q7QUFpQnREO0lBQUE7SUFDQSxDQUFDO0lBRFksWUFBWTtRQWZ4QixlQUFRLENBQUM7WUFDTixPQUFPLEVBQUU7Z0JBQ0wsOEJBQWdCO2dCQUNoQixnQ0FBYztnQkFDZCxxQkFBWTtnQkFDWixzQkFBZTthQUNsQjtZQUNELFlBQVksRUFBRTtnQkFDVixrQ0FBZTthQUNsQjtZQUNELE9BQU8sRUFBRTtnQkFDTCxrQ0FBZTtnQkFDZixzQkFBZTthQUNsQjtTQUNKLENBQUM7T0FDVyxZQUFZLENBQ3hCO0lBQUQsbUJBQUM7Q0FBQSxBQURELElBQ0M7QUFEWSxvQ0FBWSJ9


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/shared.module.ts
// module id = 134
// module chunks = 0